import * as Sentry from "@sentry/browser";

import { withMixpanel } from "@application/initializers/mixpanel";
import { SENTRY_ENABLED } from "@application/initializers/sentry";

export const unidentify = () => {
  withMixpanel((mixpanel) => mixpanel.reset());

  if (SENTRY_ENABLED) {
    Sentry.setUser(null);
  }
};
